import { Calc } from "../../math/Calc.js";
import { ScrollbarData } from "../Scrollbar.js";
import { ScrollbarListDynamic } from "../ScrollbarListDynamic.js";
import { IScrollbarBehaviour } from "./IScrollbarBehaviour.js";

export class ScrollbarBehaviourDirect implements IScrollbarBehaviour {
    public getIndex(scrollbar: ScrollbarListDynamic): number {
        if (scrollbar.view.getItems().length === 0) {
            if ((scrollbar.thumb.offsetHeight + scrollbar.dragger.top) > (scrollbar.track.offsetHeight))
                return 1;
            return -1;
        }

        var trackRange = scrollbar.track.offsetHeight - scrollbar.thumb.getBoundingClientRect().height;
        var ratio = Calc.clamp(scrollbar.dragger.top / trackRange, 0, 1);
        var scrollTop = Math.ceil(ratio * (scrollbar.view.scroller.scrollHeight - scrollbar.view.scroller.clientHeight));
        scrollTop -= scrollbar.view.content.offsetTop;

        var items = scrollbar.view.getItems();
        if (scrollTop < 0)
            return -1;

        for (var item of items) {
            if (item.offsetTop <= scrollTop && (item.offsetTop + item.height) > scrollTop) {
                return item.index;
            }
        }

        return items.length;
    }

    public fromView(scrollbar: ScrollbarListDynamic): ScrollbarData {
        return {
            scrollHeight: scrollbar.view.scroller.scrollHeight,
            scrollTop: scrollbar.view.scroller.scrollTop,
            clientHeight: scrollbar.view.scroller.clientHeight
        };
    }
}